(function () {
    'use strict';

    function workflowStateService($rootScope, $log, $filter, $timeout,
        workflowDataService, notifyService, sessionDataService, mailRequestDataService,
        workflowConfigurationDataService) {
        var state = this;
        state.workflow = {};
        sessionDataService.loadSession().then(function (sessionData) {
            state.sessionData = sessionData;
        });

        function getCleanPath(path) {
            if (path === "") {
                return "Entire Project";
            }

            var pathParts = path.split("_");
            var pathPartsLeftCount = pathParts.length;
            var pathString = "";

            while (pathParts.length > 1) {
                if (pathParts[0] === "Phase") {
                    pathString += "Phase - " + pathParts[1] + " ";
                    pathParts.splice(0, 2);
                }

                if (pathParts[0] === "InformationPart") {
                    pathString += "- " + pathParts[1] + " ";
                    pathParts.splice(0, 2);
                }

                if (pathParts[0] === "BlobSummary") {
                    var pathObject = getObjectFromPath(state.workflow, path);
                    pathString += "- " + pathObject.FileName + " ";
                    pathParts.splice(0, 2);
                }

                if (pathParts[0] === "InternalContent") {
                    pathString += "Internal Files ";
                    pathParts.splice(0, 1);
                }

                if (pathPartsLeftCount === pathParts.length) {
                    throw new Error('Could not parse path ' + path);
                }

                pathPartsLeftCount = pathParts.length;
            }

            return pathString;
        }

        function getAccessToPath(path, sharingPathsAndPermissions, workflowAccessLevel) {
            // Default permissions for internal content
            if (path.indexOf("InternalContent") !== -1) {
                return {
                    View: true,
                    Edit: true,
                    Share: false,
                    Notes: false,
                    ShowPartners: false
                }
            }

            var object = getObjectFromPath(state.workflow, path);
            var defaultSharingAndShowPartnersPermissionForOwnersAndAdmins = (path.indexOf("InternalContent") !== -1) ? false : true;

            if (!object || object.IsRemoved) {
                return {
                    View: false,
                    Edit: false,
                    Share: false,
                    Notes: false,
                    ShowPartners: false
                }
            }

            if (workflowAccessLevel === 'ProjectAdmin') {
                return {
                    View: true,
                    Edit: true,
                    Share: defaultSharingAndShowPartnersPermissionForOwnersAndAdmins,
                    Notes: true,
                    ShowPartners: defaultSharingAndShowPartnersPermissionForOwnersAndAdmins
                };
            }

            if (workflowAccessLevel === 'ProjectOwner') {
                return {
                    View: true,
                    Edit: !state.workflow.AdminConfigModifyingOnly,
                    Share: defaultSharingAndShowPartnersPermissionForOwnersAndAdmins ? !state.workflow.AdminSharingOnly : false,
                    Notes: !state.workflow.AdminUnderwritingNotesOnly,
                    ShowPartners: defaultSharingAndShowPartnersPermissionForOwnersAndAdmins
                };
            }

            var access = {
                View: false,
                Edit: false,
                Share: false,
                Notes: false,
                ShowPartners: false
            };

            var sortedPathsAndPermissions = sharingPathsAndPermissions.sort(function (a, b) {
                if (a.Path < b.Path) {
                    return -1;
                }
                if (b.Path < a.Path) {
                    return 1;
                }
                return 0;
            });

            for (var i = 0; i < sortedPathsAndPermissions.length; i++) {
                // Set the permissions if it is a match, a child or the project is shared
                // do not break, so the permission can be set
                if (path === sortedPathsAndPermissions[i].Path ||
                    path.indexOf(sortedPathsAndPermissions[i].Path) !== -1 ||
                    // We want to exclude internal files from this hiearchy since it must be directly shared
                    (sortedPathsAndPermissions[i].Path === "" && !object.isInternalFiles)) {
                    access.View = sortedPathsAndPermissions[i].Permissions["View"] || false;
                    access.Edit = sortedPathsAndPermissions[i].Permissions["Edit"] || false;
                    access.Share = sortedPathsAndPermissions[i].Permissions["Share"] || false;
                    access.Notes = sortedPathsAndPermissions[i].Permissions["Notes"] || false;
                    access.ShowPartners = true;
                }
                    // if the path is not the entire project and the item in the collection's path is not a child
                    // then we need to supply view only permissions
                else if (path !== "" && sortedPathsAndPermissions[i].Path.indexOf(path) !== -1) {
                    access.View = true;
                    access.Edit = false;
                    access.Share = false;
                    access.Notes = false;
                    access.ShowPartners = false;
                }
            }
            return access;
        }

        function getUnderwritingNotesForPath(path, originalCollection) {
            if (!originalCollection) {
                var notes = state.workflow.UnderwritingNotes.filter(function (note) {
                    return note.Path === path;
                });

                return angular.copy($filter('orderBy')(notes, 'UpdatedDate', true));
            }

            return originalCollection;
        }

        function updateInformationPart(informationPart, parent, sharingPathsAndPermissions, skipPartnersAndNotes) {
            informationPart.Path = parent.Path + "_InformationPart_" + informationPart.Title;
            informationPart.Access = getAccessToPath(informationPart.Path, sharingPathsAndPermissions,
                state.workflow.AccessLevel);

            if (!skipPartnersAndNotes) {
                informationPart.Partners = getPartners(informationPart.Path);
                informationPart.Referrals = getReferrals(informationPart.Path);
                informationPart.Partners.forEach(function(partner) {
                    var sharingPartner = state.workflow.SharingConnections.find(function(connection) {
                        return connection.EntityId === partner.Id;
                    });
                    var sharingConnection = sharingPartner.PathsAndPermissions.find(function(pathAndPermissions) {
                        return pathAndPermissions.Path === informationPart.Path;
                    });

                    partner.Access = getAccessToPath(informationPart.Path,
                        sharingPartner.PathsAndPermissions,
                        'SharingPartner');
                    partner.IsVisible = sharingConnection && !sharingConnection.IsPrivate;
                });

                informationPart.ProjectUnderwritingNotes = getUnderwritingNotesForPath(informationPart.Path,
                    informationPart.ProjectUnderwritingNotes);

                var notesCount = informationPart.ProjectUnderwritingNotes.filter(function (note) { return !note.IsDeleted; })
                    .length;
                var notesText = !informationPart.Access.Notes ? "" : (notesCount === 0 ? "notes" : notesCount.toString() + " note" + (notesCount > 1 ? "s" : ""));

                if (informationPart.BlobSummaries) {
                    var blobCount = informationPart.BlobSummaries
                        .filter(function (blob) {
                            return !blob.IsRemoved;
                        }).length;

                    informationPart.ExpandText = blobCount + ' ' +
                        (length == 1 ? 'document' : 'documents');

                    informationPart.BlobSummaries.forEach(function (blob) {
                        var extension = blob.FileName.split('.').pop();
                        blob.Extension =  extension === blob.FileName ? null : '.' + extension;
                        blob.FileNameWithoutExtension = blob.FileName.substring(0, blob.FileName.length - blob.Extension.length);
                        blob.OriginalFileNameWithoutExtension = blob.FileNameWithoutExtension;
                    });
                }

                if (informationPart.RequiredDownloads) {
                    informationPart.RequiredDownloads.forEach(function (requiredDownload) {
                        updateRequiredDownload(requiredDownload, informationPart, sharingPathsAndPermissions);
                    });
                }

                if (informationPart.Questions) {
                    var questionCount = informationPart.Questions
                        .filter(function (question) {
                            return !question.IsRemoved;
                        }).length;

                    informationPart.ExpandText = questionCount + ' ' +
                        (length == 1 ? 'question' : 'questions');

                    informationPart.originalQuestionSetData = backupQuestionSet(informationPart);

                    parent.hasQuestionContent = informationPart.Questions.some(function (question) {
                        return !question.IsRemoved;
                    });
                }

                if (notesText) {
                    informationPart.ExpandText += ", " + notesText;
                }

                informationPart.ExpandText += " " + "attached";
            }

            if (informationPart.BlobSummaries) {
                informationPart.BlobSummaries.forEach(function (blob) {
                    blob.Path = informationPart.Path + "_BlobSummary_" + blob.BlobReference;
                    blob.Access = getAccessToPath(blob.Path, sharingPathsAndPermissions,
                        state.workflow.AccessLevel);
                    blob.UploadedByCleanName = blob.UploadedByEntity
                        ? blob.UploadedByEntity.Contact.FirstName + ' ' + blob.UploadedByEntity.Contact.LastName
                        : 'N/A';

                    if (!skipPartnersAndNotes) {
                        blob.Partners = getPartners(blob.Path);
                        blob.Referrals = getReferrals(blob.Path);
                        blob.Partners.forEach(function (partner) {
                            var sharingPartner = state.workflow.SharingConnections.find(function (connection) {
                                return connection.EntityId === partner.Id;
                            });
                            partner.Access = getAccessToPath(blob.Path, sharingPartner.PathsAndPermissions, 'SharingPartner');
                        });
                        blob.ProjectUnderwritingNotes = getUnderwritingNotesForPath(blob.Path,
                            blob.ProjectUnderwritingNotes);
                    }
                });
            }
        }

        function updateRequiredDownload(requiredDownload, informationPart, sharingPathsAndPermissions) {
            requiredDownload.Path = informationPart.Path + "_RequiredDownload_" + requiredDownload.Title;
            requiredDownload.Access = getAccessToPath(requiredDownload.Path, sharingPathsAndPermissions,
                state.workflow.AccessLevel);

            if (requiredDownload.BlobSummary) {
                requiredDownload.BlobSummary.Path = requiredDownload.Path + "_BlobSummary_" +
                requiredDownload.BlobSummary.BlobReference;
                requiredDownload.BlobSummary.Access = getAccessToPath(requiredDownload.BlobSummary.Path,
                    sharingPathsAndPermissions,
                    state.workflow.AccessLevel);
                requiredDownload.BlobSummary.UploadedByCleanName = requiredDownload.BlobSummary.UploadedByEntity
                    ? requiredDownload.BlobSummary.UploadedByEntity.Contact.FirstName + ' ' +
                        requiredDownload.BlobSummary.UploadedByEntity.Contact.LastName
                    : 'N/A';

                requiredDownload.Partners = getPartners(requiredDownload.BlobSummary.Path);
                requiredDownload.Referrals = getReferrals(requiredDownload.BlobSummary.Path);
                requiredDownload.Partners.forEach(function (partner) {
                    var sharingPartner = state.workflow.SharingConnections.find(function (connection) {
                        return connection.EntityId === partner.Id;
                    });
                    partner.Access = getAccessToPath(requiredDownload.BlobSummary.Path,
                        sharingPartner.PathsAndPermissions, 'SharingPartner');
                });
                requiredDownload.ProjectUnderwritingNotes = getUnderwritingNotesForPath(requiredDownload.Path,
                    requiredDownload.ProjectUnderwritingNotes);
                requiredDownload.OriginalPrompt = requiredDownload.Prompt;
            }
        }

        // Wrapping it in the session call for now
        function update(workflow, silent) {
            return sessionDataService.loadSession().then(function (sessionData) {
                return updateWithSessionData(workflow, silent, sessionData);
            });
        }

        function updateWithSessionData(workflow, silent, sessionData) {
            state.workflow = workflow;

            // clean up ophaned sharing connections
            state.workflow.SharingConnections = state.workflow.SharingConnections.filter(function (sharingConnection) {
                return sharingConnection.PathsAndPermissions.length > 0;
            });

            var ownerEntityId = workflow.EntityId;
            var accessingEntityId = sessionData.EntityId;
            var sharingPathsAndPermissions = [];
            if (ownerEntityId !== accessingEntityId) {
                if (sessionData.IsAdminEntity) {
                    state.workflow.AccessLevel = "ProjectAdmin";
                }
                else if (sessionData.EntityType === 'Insurance Broker' &&
                    sessionData.SiteMappings.some(function (mapping) {
                        return mapping.SiteConfigurationId.toLowerCase() === state.workflow.Entity.SiteConfigurationId.toLowerCase() &&
                            mapping.Role === "Broker Administrator";
                })) {
                    state.workflow.AccessLevel = "ProjectAdmin";
                }
                else {
                    var sharingPartner = state.workflow.SharingConnections.find(function (connection) {
                        return connection.EntityId === accessingEntityId;
                    });
                    if (sharingPartner) {
                        state.workflow.AccessLevel = "SharingPartner";
                        if (sharingPartner.PathsAndPermissions.length === 0) {
                            $rootScope.$broadcast('response_error');
                            $log.error("You cannot access this workflow");
                        }
                        sharingPathsAndPermissions = sharingPartner.PathsAndPermissions;
                    }
                    else {
                        $rootScope.$broadcast('response_error');
                        $log.error("You cannot access this workflow");
                    }
                }
            }
            else {
                state.workflow.AccessLevel = "ProjectOwner";
            }

            if (sessionData.EntityType === "Site Administrator" ||
                sessionData.EntityType === "Portal Administrator") {
                state.workflow.SharingConnections.forEach(function (connection) {
                    connection.PathsAndPermissions.forEach(function (pathAndPermissions) {
                        pathAndPermissions.IsVisible = true;
                    });

                    connection.IsVisible = true;
                });
            }
            else {
                state.workflow.SharingConnections.forEach(function (connection) {
                    connection.PathsAndPermissions.forEach(function (pathAndPermissions) {
                        pathAndPermissions.IsVisible = !pathAndPermissions.IsPrivate;
                    });

                    connection.IsVisible = connection.PathsAndPermissions.some(function (pathAndPermissions) {
                        return pathAndPermissions.IsVisible;
                    });
                });
            }

            state.workflow.UnderwritingNotes.forEach(function (note) {
                note.UpdatedByCleanName = note.UpdatedByEntity
                    ? note.UpdatedByEntity.Contact.FirstName + ' ' + note.UpdatedByEntity.Contact.LastName
                    : 'N/A';
            });

            state.workflow.Path = "";
            state.workflow.Access = getAccessToPath(state.workflow.Path, sharingPathsAndPermissions, state.workflow.AccessLevel);
            state.workflow.ProjectUnderwritingNotes = getUnderwritingNotesForPath("",
                state.workflow.ProjectUnderwritingNotes);
            state.workflow.Partners = getPartners("");
            state.workflow.Referrals = getReferrals("");

            state.workflow.InternalContent.isInternalFiles = true;
            state.workflow.InternalContent.Path = "InternalContent";
            state.workflow.InternalContent.Access = getAccessToPath(state.workflow.InternalContent.Path,
                sharingPathsAndPermissions, state.workflow.AccessLevel);
            var skipPartnersAndNotesForInternalContent = true;
            state.workflow.InternalContent.InformationParts.forEach(function (informationPart) {
                updateInformationPart(informationPart, state.workflow.InternalContent, sharingPathsAndPermissions, skipPartnersAndNotesForInternalContent);
            });
            
            
            state.workflow.InternalContent.hasNoDocuments = !state.workflow.InternalContent.InformationParts.some(function (informationPart) {
                return !informationPart.IsRemoved && informationPart.Access.View && informationPart.$type === 'Ecap.Api.ViewModels.DocumentViewModel, Ecap.Api';
            });

            state.workflow.InternalContent.hasNoQuestionSets = !state.workflow.InternalContent.InformationParts.some(function (informationPart) {
                return !informationPart.IsRemoved && informationPart.Access.View && informationPart.$type === 'Ecap.Api.ViewModels.QuestionSetViewModel, Ecap.Api';
            });

            function createPhaseDescription(descriptionStripped, phase, index) {
                var cutDescription = $filter('cut')(descriptionStripped, false, 80);
                phase.Description = cutDescription;
                if (cutDescription.length < descriptionStripped.length) {
                    phase.Description = '<span class="phase-description-body">' + phase.Description + '</span><span class="phase-description-see-more">SEE MORE</span>';
                }
            }

            var workflowPercentageTracker = {
                numberOfItems: 0,
                numberOfCompletedItems: 0
            };

            var forceSave = false;
            state.workflow.Phases.forEach(function (phase, index) {
                phase.OriginalPercentageComplete = angular.copy(phase.PercentageComplete),
                phase.PercentageComplete = getPhasePercentageComplete(phase, workflowPercentageTracker);
                var percentChanged = false;
                if (phase.OriginalPercentageComplete !== phase.PercentageComplete) {
                    forceSave = true;
                    percentChanged = true;
                }

                if (phase.HeaderCopyHtmlOverride) {
                    createPhaseDescription(phase.HeaderCopyHtmlOverride.replace(/(<([^>]+)>)/ig,""), phase, index);
                } else if (phase.HeaderCopyHtmlTemplateId) {
                    workflowConfigurationDataService.loadHtmlTemplate(phase.HeaderCopyHtmlTemplateId).then(function (response) {
                        if (response && response.Html) {
                             createPhaseDescription(response.Html.replace(/(<([^>]+)>)/ig,""), phase, index);
                        }
                    });
                }

                $timeout(function () {
                    $rootScope.$emit("phasePercentageCompleteChange", {
                        phaseIndex: index,
                        percentageComplete: phase.PercentageComplete / 100,
                        percentChanged: percentChanged
                    });
                });

                phase.Path = "Phase_" + phase.Title;
                phase.Access = getAccessToPath(phase.Path, sharingPathsAndPermissions, state.workflow.AccessLevel);
                phase.Partners = getPartners(phase.Path);
                phase.Referrals = getReferrals(phase.Path);
                phase.Partners.forEach(function (partner) {
                    var sharingPartner = state.workflow.SharingConnections.find(function (connection) {
                        return connection.EntityId === partner.Id;
                    });
                    partner.Access = getAccessToPath(phase.Path, sharingPartner.PathsAndPermissions, 'SharingPartner');
                });
                phase.ProjectUnderwritingNotes = getUnderwritingNotesForPath(phase.Path,
                    phase.ProjectUnderwritingNotes);

                phase.Index = state.workflow.Phases.indexOf(phase);
                phase.InformationParts.forEach(function (informationPart) {
                    updateInformationPart(informationPart, phase, sharingPathsAndPermissions);
                });

                phase.hasNoContents = !phase.InformationParts.some(function (informationPart) {
                    return !informationPart.IsRemoved && informationPart.Access.View;
                }) && phase.Access.Edit;

                phase.hasNoDocuments = !phase.InformationParts.some(function (informationPart) {
                    return !informationPart.IsRemoved && informationPart.Access.View && informationPart.$type === 'Ecap.Api.ViewModels.DocumentViewModel, Ecap.Api';
                }) && phase.Access.Edit;

                phase.hasNoQuestionSets = !phase.InformationParts.some(function (informationPart) {
                    return !informationPart.IsRemoved && informationPart.Access.View && informationPart.$type === 'Ecap.Api.ViewModels.QuestionSetViewModel, Ecap.Api';
                }) && phase.Access.Edit;
            });

            state.workflow.OriginalPercentageComplete = angular.copy(state.workflow.percentageComplete);
            state.workflow.PercentageComplete = workflowPercentageTracker.numberOfItems === 0 ? 0 : Math.floor(100 * (workflowPercentageTracker.numberOfCompletedItems / workflowPercentageTracker.numberOfItems));

            if (state.workflow.OriginalPercentageComplete !== state.workflow.PercentageComplete) {
                forceSave = true;
            }

            // update current phse index to the last phase with progress
            state.workflow.originalPhaseIndex = state.workflow.CurrentPhaseIndex;
            for (var phaseIndex = state.workflow.Phases.length - 1; phaseIndex >= 0; phaseIndex--) {
                if (state.workflow.Phases[phaseIndex].PercentageComplete > 0 &&
                    state.workflow.Phases[phaseIndex].Status !== 'Skipped') {
                    state.workflow.CurrentPhaseIndex = phaseIndex;
                    break;
                }
            }

            if (state.workflow.originalPhaseIndex !== state.workflow.CurrentPhaseIndex) {
                forceSave = true;
            }

            state.workflow.SharingConnections.forEach(function (connection) {
                connection.PathsAndPermissions = connection.PathsAndPermissions.sort(function (a, b) {
                    if (a.Path < b.Path) {
                        return -1;
                    }
                    if (b.Path < a.Path) {
                        return 1;
                    }
                    return 0;
                });
                connection.PathAndPermissionMappings = connection.PathsAndPermissions.map(function (pathAndPermissions) {
                    return {
                        path: pathAndPermissions.Path,
                        cleanPath: getCleanPath(pathAndPermissions.Path),
                        permissions: pathAndPermissions.Permissions,
                        isPrivate: pathAndPermissions.IsPrivate
                    }
                });
            });

            state.workflow.UnderwritingNotes.forEach(function (note) {
                var pathName = state.workflow.Title;
                var pathObject = getObjectFromPath(state.workflow, note.Path);
                if (pathObject) {
                    if (pathObject.FileName) {
                        pathName = pathObject.FileName;
                    } else {
                        pathName = pathObject.Prompt;
                    }
                }
                note.PathName = pathName;
            });

            if (!silent || forceSave) {
                workflowDataService.saveWorkflow(state.workflow).then(function (data) {
                    // TODO: Do we need anything here?
                }, function (error) {
                    // TODO: Handle potential concurrency issues
                    notifyService.notify('We could not save the changes to your workflow.', true);
                });
            }

            $rootScope.$broadcast('workflowUpdated');
            return state.workflow;
        }

        function get() {
            return state.workflow;
        }

        function getPartners(path) {
            var allPartners = state.workflow.SharingConnections.filter(function (connection) {
                var matchingConnections = connection.PathsAndPermissions.filter(function (pathAndPermissions) {
                    if (path === "") {
                        return pathAndPermissions.Path === "";
                    } else {
                        return ((path === pathAndPermissions.Path) && pathAndPermissions.IsVisible) ||
                            ((pathAndPermissions.Path === "" && path.indexOf('InternalContent') === -1) && pathAndPermissions.IsVisible) ||
                            ((pathAndPermissions.Path.length > 0 && path.indexOf(pathAndPermissions.Path) !== -1) && pathAndPermissions.IsVisible);
                    }
                });

                return matchingConnections.length > 0;
            }).map(function (item) {
                var entity = item.Entity;
                var matchingPermission = item.PathsAndPermissions.find(function (pp) {
                    return pp.Path === path;
                });
                if (matchingPermission) {
                    entity.Permissions = matchingPermission.Permissions;
                    entity.IsPrivate = matchingPermission.IsPrivate;
                }
                return entity;
            });

            return _.uniq(allPartners, function (partner) {
                return partner.Id;
            });
        };

        function getReferrals(path) {
            var allReferrals = state.workflow.Referrals.filter(function (referral) {
                    if (path === "") {
                        return referral.Path === "";
                    } else {
                        return ((path === referral.Path)) ||
                            ((referral.Path === "")) ||
                            ((referral.Path.length > 0 && path.indexOf(referral.Path) !== -1));
                    }
                }).map(function (item) {
                    var entity = {
                        Id: item.Id,
                        EmailAddress: item.EmailAddress,
                        Path: item.Path,
                        cleanPath: getCleanPath(item.Path),
                        Data: item.Data || {
                            Permissions: {
                                View: true,
                                Edit: false,
                                Share: false,
                                Notes: true
                            },
                            IsPrivate: false
                        }
                    };
                    return entity;
                });
            return allReferrals;
        };

        function resolveNotesForPath(path) {
            state.workflow.UnderwritingNotes.forEach(function (note) {
                // Resolve notes for removed phases
                if (note.Path.startsWith(path)) {
                    note.IsResolved = true;
                }
            });
        }

        function isQuestionSetComplete(questionSet) {
            var unansweredQuestion = questionSet.Questions.filter(function (question) {
                return !question.IsRemoved;
            }).find(function (question) {
                if (question.Options) {
                    return question.Options.every(function (option) { return !option.IsSelected; });
                }
                return question.Value === undefined ||
                    question.Value === null ||
                    question.Value === '' ||
                    question.Value.length === 0;
            });

            if (!unansweredQuestion) {
                return true;
            }

            return false;
        }

        function getPhasePercentageComplete(phase, workflowPercentageTracker) {
            var numberOfCompletedItems = 0;
            var numberOfItems = phase.InformationParts.filter(function (informationPart) { return !informationPart.IsRemoved; }).length;

            phase.InformationParts.filter(function (informationPart) { return !informationPart.IsRemoved; })
                .forEach(function (informationPart) {
                    if (informationPart.Questions) {
                        if (isQuestionSetComplete(informationPart)) {
                            numberOfCompletedItems += 1;
                        }
                    }
                    else if (informationPart.BlobSummaries) {
                        numberOfCompletedItems += informationPart.BlobSummaries.filter(
                            function (blob) { return !blob.IsRemoved; }).length > 0 ? 1 : 0;
                    }
                    else if (informationPart.$type ===
                        'Ecap.Api.ViewModels.DrawScheduleViewModel, Ecap.Api') {
                        if (informationPart.Items && informationPart.Items.filter(function (item) { return !item.IsRemoved; }).length > 0) {
                            numberOfCompletedItems += 1;
                        }
                    }
                    else {
                        numberOfCompletedItems += 1;
                    }
                });

            workflowPercentageTracker.numberOfItems += numberOfItems;
            workflowPercentageTracker.numberOfCompletedItems += numberOfCompletedItems;
            return numberOfCompletedItems === numberOfItems ? 100 : Math.floor(100 * (numberOfCompletedItems / numberOfItems));
        }

        function removeSharingConnectionsForPath(path) {
            state.workflow.SharingConnections.forEach(function (connection) {
                var matchingIndex = connection.PathsAndPermissions.map(function (pathAndPermissions) {
                    return pathAndPermissions.Path;
                }).indexOf(path);
                if (matchingIndex !== -1) {
                    connection.PathsAndPermissions.splice(matchingIndex, 1);
                }
            });
        }

        function addRequiredDownloadToInformationPart(phaseIndex, informationPartIndex, requiredDownload) {
            state.workflow.Phases[phaseIndex].InformationParts[informationPartIndex].RequiredDownloads.push(requiredDownload);
            update(state.workflow);
            notifyService.notify('You added ' + requiredDownload.Prompt);
        }

        function removeRequiredDownloadFromInformationPart(phase, document, requiredDownloadIndex) {
            var matchingPhase = state.workflow.Phases.find(function(workflowPhase) {
                return phase.Title === workflowPhase.Title;
            });

            var matchingDocument = matchingPhase.InformationParts.find(function(informationPart) {
                return informationPart.Title === document.Title;
            });

            var requiredDownloadToRemove = matchingDocument.RequiredDownloads[requiredDownloadIndex];
            requiredDownloadToRemove.IsRemoved = true;
            resolveNotesForPath(requiredDownloadToRemove.Path);
            update(state.workflow);
            notifyService.notify('You removed ' + requiredDownloadToRemove.Prompt);
        }

        function addInformationPartToPhase(phase, informationPart) {
            var matchingPhase = state.workflow.Phases.find(function(workflowPhase) {
                return phase.Title === workflowPhase.Title;
            });

            if (!matchingPhase) {
                throw new Error('Could not find phase ' + phase.Title);
            }

            matchingPhase.InformationParts.push(informationPart);
            update(state.workflow);
            notifyService.notify('You added ' + informationPart.Prompt);
        }

        function removeInformationPartFromPhase(phase, partIndex) {
            var matchingPhase = state.workflow.Phases.find(function(workflowPhase) {
                return phase.Title === workflowPhase.Title;
            });

            if (!matchingPhase) {
                throw new Error('Could not find phase ' + phase.Title);
            }

            var phaseIndex = state.workflow.Phases.indexOf(phase);
            var informationPartToRemove = state.workflow.Phases[phaseIndex].InformationParts[partIndex];
            informationPartToRemove.IsRemoved = true;
            removeSharingConnectionsForPath(informationPartToRemove.Path);
            informationPartToRemove.Title += "-removed";
            update(state.workflow);
            notifyService.notify('You removed ' + informationPartToRemove.Prompt);
        }

        function addInformationPartToInternalContent(informationPart) {
            state.workflow.InternalContent.InformationParts.push(informationPart);
            update(state.workflow);
            notifyService.notify('You added ' + informationPart.Prompt);
        }

        function removeInformationPartFromInternalContent(partIndex) {
            var informationPartToRemove = state.workflow.InternalContent.InformationParts[partIndex];
            informationPartToRemove.IsRemoved = true;
            removeSharingConnectionsForPath(informationPartToRemove.Path);
            informationPartToRemove.Title += "-removed";
            update(state.workflow);
            notifyService.notify('You removed ' + informationPartToRemove.Prompt);
        }

        function addPhase(titleAndPrompt) {
            state.workflow.Phases.push({
                Title: titleAndPrompt,
                Prompt: titleAndPrompt,
                Status: 'Pending',
                RequiredDownloads: [],
                InformationParts: [
                    {
                        $type: "Ecap.Api.ViewModels.DocumentViewModel, Ecap.Api",
                        Title: 'Documents',
                        Prompt: 'Documents',
                        BlobSummaries: []
                    },
                    {
                        $type: "Ecap.Api.ViewModels.QuestionSetViewModel, Ecap.Api",
                        Title: 'Questions',
                        Prompt: 'Questions',
                        Questions: []
                    }
                ],
                PercentageComplete: 0,
                EntitySearchIndex: state.workflow.EntitySearchIndex,
                AdminEntitySearchIndex: state.workflow.AdminEntitySearchIndex
            });
            update(state.workflow);
            notifyService.notify('You added a phase to the project');
        }

        function removePhase(phaseIndex) {
            var phaseToRemovePrompt = Object.assign({}, state.workflow.Phases[phaseIndex]).Prompt;
            state.workflow.Phases[phaseIndex].IsRemoved = true;

            var phasePath = state.workflow.Phases[phaseIndex].Path;
            removeSharingConnectionsForPath(phasePath);
            resolveNotesForPath(phasePath);

            state.workflow.Phases[phaseIndex].Title += "-removed";
            notifyService.notify('You removed ' + phaseToRemovePrompt);
            // push phase to back
            state.workflow.Phases.push(state.workflow.Phases.splice(phaseIndex, 1)[0]);

            // if the phase was the last one, we need to check the current index and move it back
            if (phaseIndex === state.workflow.CurrentPhaseIndex - 1) {
                state.workflow.CurrentPhaseIndex = state.workflow.CurrentPhaseIndex - 1;
            }

            update(state.workflow);
        }

        function saveUnderwritingNote(note) {
            var existingNote = state.workflow.UnderwritingNotes.find(function (noteItem) {
                return noteItem.NoteId === note.NoteId;
            });

            var description = '';
            if (existingNote) {
                var originalNote = angular.copy(existingNote.Note);
                existingNote.Note = note.Note;
                existingNote.UpdatedByUserName = state.sessionData.UserName;
                existingNote.UpdatedByEntityId = state.sessionData.EntityId;
                existingNote.UpdatedByEntity = state.sessionData.Entity;
                notifyService.notify('You updated a note');
                description = 'The note: "' + originalNote + '" was changed to "' + note.Note + '"';
            }
            else {
                var noteDate = (new Date()).toISOString();
                state.workflow.UnderwritingNotes.push({
                    NoteId: note.NoteId,
                    Note: note.Note,
                    Path: note.Path,
                    UpdatedDate: noteDate,
                    UpdatedByUserName: state.sessionData.UserName,
                    UpdatedByEntityId: state.sessionData.EntityId,
                    UpdatedByEntity: state.sessionData.Entity,
                    CreatedByUserName: note.CreatedByUserName,
                    CreatedByEntityId: note.CreatedByEntityId,
                    CreatedByEntity: note.CreatedByEntity,
                    TargetUsers: note.TargetUsers || {}
                });
                note.UpdatedDate = noteDate;
                notifyService.notify('You added a note');
                description = 'The note "' + note.Note + '" was added';
            }

            note.UpdatedByUserName = state.sessionData.UserName;
            note.UpdatedByEntityId = state.sessionData.EntityId;
            note.UpdatedByEntity = state.sessionData.Entity;
            note.UpdatedByCleanName = state.sessionData.Entity
                ? state.sessionData.Entity.Contact.FirstName + ' ' + state.sessionData.Entity.Contact.LastName
                : 'N/A';
            update(state.workflow);

            var pathObject = getObjectFromPath(state.workflow, note.Path);

            mailRequestDataService.sendWorkflowUpdate({
                EntityId: state.sessionData.EntityId,
                WorkflowId: state.workflow.Id.split('/')[1],
                Path: note.Path,
                Context: 'Note',
                RecordedActivity:
                {
                    // TODO: Use fields other than description or add this
                    // to the actual workflow activities
                    Description: description,
                    UserName: state.sessionData.UserName,
                    Date: (new Date()).toISOString(),
                    UsersToNotify: pathObject.Partners.filter(function (partner) {
                        return partner.Access.Notes;
                    }).map(function (filteredPartner) {
                        return filteredPartner.UserName;
                    })
                }
            });
        }

        function resolveUnderwritingNote(note) {
            var description = '';
            for (var i = 0; i < state.workflow.UnderwritingNotes.length; i++) {
                var workflowNote = state.workflow.UnderwritingNotes[i];
                if (note.NoteId === workflowNote.NoteId) {
                    workflowNote.IsResolved = true;
                    description = 'The note "' + note.Note + '" was resolved';
                    workflowNote.UpdatedByUserName = state.sessionData.UserName;
                    workflowNote.UpdatedByEntityId = state.sessionData.EntityId;
                    workflowNote.UpdatedByEntity = state.sessionData.Entity;
                    workflowNote.UpdatedByCleanName = state.sessionData.Entity
                        ? state.sessionData.Entity.Contact.FirstName + ' ' + state.sessionData.Entity.Contact.LastName
                        : 'N/A';
                    notifyService.notify('You resolved a note');
                    break;
                }
            }

            var pathObject = getObjectFromPath(state.workflow, note.Path);
            var notesIdsToBeArchived = pathObject.ProjectUnderwritingNotes.filter(function (note) {
                return !note.IsDeleted;
            }).map(function (note) { return note.NoteId; });

            state.workflow.UnderwritingNoteArchives.push(
                {
                    UnderwritingNotes: state.workflow.UnderwritingNotes.filter(function (note) {
                        return notesIdsToBeArchived.indexOf(note.NoteId) !== -1;
                    })
                }
            );

            state.workflow.UnderwritingNotes = state.workflow.UnderwritingNotes.filter(function (note) {
                return notesIdsToBeArchived.indexOf(note.NoteId) === -1;
            });

            pathObject.ProjectUnderwritingNotes = pathObject.ProjectUnderwritingNotes.filter(function (note) {
                return notesIdsToBeArchived.indexOf(note.NoteId) === -1;
            });

            update(state.workflow);

            mailRequestDataService.sendWorkflowUpdate({
                EntityId: state.sessionData.EntityId,
                WorkflowId: state.workflow.Id.split('/')[1],
                Path: note.Path,
                Context: 'Note',
                RecordedActivity:
                {
                    // TODO: Use fields other than description or add this
                    // to the actual workflow activities
                    Description: description,
                    UserName: state.sessionData.UserName,
                    Date: (new Date()).toISOString(),
                    UsersToNotify: pathObject.Partners.filter(function (partner) {
                        return partner.Access.Notes;
                    }).map(function (filteredPartner) {
                        return filteredPartner.UserName;
                    })
                }
            });
        }

        function removeUnderwritingNote(noteId) {
            var existingNote = state.workflow.UnderwritingNotes.find(function (note) {
                return note.NoteId === noteId;
            });

            if (!existingNote) {
                notifyService.notify('There was an error deleting the note', true);
            }

            existingNote.IsDeleted = true;
            notifyService.notify('You deleted a note');
            update(state.workflow);
        }

        function deleteUpload(phase, document, index) {
            var blobPath;
            var fileName;
            if (phase.isInternalFiles) {
                var internalInformationPartIndex = state.workflow.InternalContent.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(document.Title);
                state.workflow.InternalContent.InformationParts[internalInformationPartIndex].BlobSummaries[index].IsRemoved = true;
                blobPath = state.workflow.InternalContent.InformationParts[internalInformationPartIndex].BlobSummaries[index].Path;
                fileName = state.workflow.InternalContent.InformationParts[internalInformationPartIndex].BlobSummaries[index].FileName;
            }
            else {
                var matchingPhase = state.workflow.Phases.find(function (workflowPhase) {
                    return phase.Title === workflowPhase.Title;
                });

                var informationPartIndex = matchingPhase.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(document.Title);

                matchingPhase.InformationParts[informationPartIndex].BlobSummaries[index].IsRemoved = true;
                blobPath = matchingPhase.InformationParts[informationPartIndex].BlobSummaries[index].Path;
                fileName = matchingPhase.InformationParts[informationPartIndex].BlobSummaries[index].FileName;
            }

            // Remove sharing paths and resolve notes
            removeSharingConnectionsForPath(blobPath);
            resolveNotesForPath(blobPath);

            update(state.workflow);
            notifyService.notify('You deleted ' + fileName);
        }

        function updateDocumentPrompt(phase, document) {
            if (phase.isInternalFiles) {
                var internalInformationPartIndex = state.workflow.InternalContent.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(document.Title);
                state.workflow.InternalContent.InformationParts[internalInformationPartIndex].Prompt = document.Prompt;
            }
            else {
                var matchingPhase = state.workflow.Phases.find(function (workflowPhase) {
                    return phase.Title === workflowPhase.Title;
                });

                var informationPartIndex = matchingPhase.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(document.Title);

                matchingPhase.InformationParts[informationPartIndex].Prompt = document.Prompt;
            }
            update(state.workflow);
        }

        function updateRequiredDownloadPrompt(phase, documentPart, requiredDownload) {
            var matchingPhase = state.workflow.Phases.find(function (workflowPhase) {
                return phase.Title === workflowPhase.Title;
            });

            var matchingPart = matchingPhase.InformationParts.find(function (informationPart) {
                return documentPart.Title == informationPart.Title;
            });

            var requiredDownloadIndex = matchingPart.RequiredDownloads.map(function (template) {
                return template.Title;
            }).indexOf(requiredDownload.Title);

            matchingPart.RequiredDownloads[requiredDownloadIndex].Prompt = requiredDownload.Prompt;
            update(state.workflow);
        }

        function updateBlobSummmaryFileName(phase, document, blobSummary, index) {
            var matchingPhase = state.workflow.Phases.find(function (workflowPhase) {
                return phase.Title === workflowPhase.Title;
            });

            var informationPartIndex = matchingPhase.InformationParts.map(function (part) {
                return part.Title;
            }).indexOf(document.Title);

            matchingPhase.InformationParts[informationPartIndex].BlobSummaries[index].FileName = blobSummary.FileNameWithoutExtension + blobSummary.Extension;
            update(state.workflow);
        }

        function backupQuestionSet(questionSet) {
            var copy = angular.copy(questionSet);
            if (copy.originalQuestionSetData) {
                delete copy.originalQuestionSetData;
            }
            return copy;
        }

        function syncQuestionSet(phase, questionSet) {
            var isAlreadyComplete = false;
            if (phase.isInternalFiles) {
                var internalInformationPartIndex = state.workflow.InternalContent.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(document.Title);
                state.workflow.InternalContent.InformationParts[internalInformationPartIndex] = questionSet;
            }
            else {
                var matchingPhase = state.workflow.Phases.find(function (workflowPhase) {
                    return phase.Title === workflowPhase.Title;
                });

                var informationPartIndex = matchingPhase.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(questionSet.Title);

                isAlreadyComplete = isQuestionSetComplete(matchingPhase.InformationParts[informationPartIndex].originalQuestionSetData);

                matchingPhase.InformationParts[informationPartIndex] = questionSet;
            }

            // Check if quesrtion set is complete and send update
            if (!isAlreadyComplete)
            {
                if (isQuestionSetComplete(questionSet)) {
                    var pathObject = getObjectFromPath(state.workflow, questionSet.Path);

                    mailRequestDataService.sendWorkflowUpdate({
                        EntityId: state.sessionData.EntityId,
                        WorkflowId: state.workflow.Id.split('/')[1],
                        Path: questionSet.Path,
                        Context: 'InformationPart',
                        RecordedActivity:
                        {
                            // TODO: Use fields other than description or add this
                            // to the actual workflow activities
                            Description: 'Question Set "' + questionSet.Prompt + '" was completed',
                            UserName: state.sessionData.UserName,
                            Date: (new Date()).toISOString(),
                            UsersToNotify: pathObject.Partners.filter(function (partner) {
                                return partner.Access.Notes;
                            }).map(function (filteredPartner) { 
                                return filteredPartner.UserName;
                            })
                        }
                    });
                }
            }

            update(state.workflow);
        }

        function syncDrawSchedule(phase, drawSchedule) {
            if (phase.isInternalFiles) {
                var internalInformationPartIndex = state.workflow.InternalContent.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(drawSchedule.Title);

                state.workflow.InternalContent[internalInformationPartIndex] = drawSchedule;
            }
            else {
                var matchingPhase = state.workflow.Phases.find(function (workflowPhase) {
                    return phase.Title === workflowPhase.Title;
                });

                var informationPartIndex = matchingPhase.InformationParts.map(function (part) {
                    return part.Title;
                }).indexOf(drawSchedule.Title);

                matchingPhase.InformationParts[informationPartIndex] = drawSchedule;
            }
            update(state.workflow);
        }

        function getObjectFromPath(workflow, path) {
            var pathObject = workflow;
            if (path === "" || !path) {
                return pathObject;
            }

            var pathParts = path.split("_");
            var pathPartsLeftCount = pathParts.length;

            while (pathParts.length > 1) {
                if (pathParts[0] === 'Phase') {
                    var phaseIndex = pathObject.Phases.indexOf(pathObject.Phases.find(function (phase) {
                        return phase.Title === pathParts[1];
                    }));

                    pathObject = pathObject.Phases[phaseIndex];

                    pathParts.splice(0, 2);
                }

                if (pathParts[0] === 'RequiredDownload') {
                    var requiredDownloadIndex = pathObject.RequiredDownloads.indexOf(
                        pathObject.RequiredDownloads.find(function (requiredDownload) {
                            return requiredDownload.Title === pathParts[1];
                        }));

                    pathObject = pathObject.RequiredDownloads[requiredDownloadIndex];

                    pathParts.splice(0, 2);
                }

                if (pathParts[0] === 'InformationPart') {
                    var informationPartIndex = pathObject.InformationParts.indexOf(
                        pathObject.InformationParts.find(function (informationPart) {
                            return informationPart.Title === pathParts[1];
                        }));

                    pathObject = pathObject.InformationParts[informationPartIndex];

                    pathParts.splice(0, 2);
                }

                if (pathParts[0] === 'BlobSummary') {
                    if (Array.isArray(pathObject.BlobSummaries)) {
                        var blobIndex = pathObject.BlobSummaries.indexOf(
                            pathObject.BlobSummaries.find(function (blob) {
                                return blob.BlobReference === pathParts[1];
                            }));

                        pathObject = pathObject.BlobSummaries[blobIndex];
                    } else {
                        pathObject = pathObject.BlobSummary;
                    }

                    pathParts.splice(0, 2);
                }

                if (pathParts[0] === 'InternalContent') {
                    pathObject = pathObject.InternalContent;
                    pathObject.isInternalFiles = true;

                    pathParts.splice(0, 1);
                }

                if (pathPartsLeftCount === pathParts.length) {
                    throw new Error('Could not parse path ' + path);
                }

                pathPartsLeftCount = pathParts.length;
            }

            return pathObject;
        }

        function getRouteDataFromPath(workflow, path) {
            var pathObject = workflow;
            if (path === "") {
                return {
                    route: 'workflow.roadmap'
                }
            }

            var pathParts = path.split("_");

            if (pathParts[0] === 'Phase') {
                var phaseIndex = pathObject.Phases.indexOf(pathObject.Phases.find(function (phase) {
                    return phase.Title === pathParts[1];
                }));

                // handle removed phase
                if (state.workflow.Phases[phaseIndex].IsRemoved) {
                    return {
                        route: 'workflow.roadmap'
                    };
                }

                return pathParts.length > 2
                ? {
                    route: 'workflow.navigator.phase',
                    phaseIndex: phaseIndex + 1
                }
                : {
                    route: 'workflow.roadmap'
                }
            } else if (pathParts[0] === 'InternalContent') {
                return {
                    route: 'workflow.internalfiles'
                }
            } else {
                return {
                    route: 'workflow.roadmap'
                }
            }
        }

        function setThumbnails(thumbnails) {
            state.thumbnails = thumbnails;
            $rootScope.$emit('thumbnailsChanged');
        }

        function getThumbnails() {
            return state.thumbnails;
        }

        function getPartnersForPath(path) {
            var object = getObjectFromPath(state.workflow, path);
            return object.Partners;
        }

        return {
            update: update,
            get: get,
            getPartners: getPartners,
            getReferrals: getReferrals,
            getObjectFromPath: getObjectFromPath,
            getRouteDataFromPath: getRouteDataFromPath,
            getCleanPath: getCleanPath,
            getPhasePercentageComplete: getPhasePercentageComplete,
            addRequiredDownloadToInformationPart: addRequiredDownloadToInformationPart,
            removeRequiredDownloadFromInformationPart: removeRequiredDownloadFromInformationPart,
            addInformationPartToPhase: addInformationPartToPhase,
            removeInformationPartFromPhase: removeInformationPartFromPhase,
            addInformationPartToInternalContent: addInformationPartToInternalContent,
            removeInformationPartFromInternalContent: removeInformationPartFromInternalContent,
            addPhase: addPhase,
            removePhase: removePhase,
            deleteUpload: deleteUpload,
            syncQuestionSet: syncQuestionSet,
            syncDrawSchedule: syncDrawSchedule,
            updateDocumentPrompt: updateDocumentPrompt,
            saveUnderwritingNote: saveUnderwritingNote,
            removeUnderwritingNote: removeUnderwritingNote,
            resolveUnderwritingNote: resolveUnderwritingNote,
            setThumbnails: setThumbnails,
            getThumbnails: getThumbnails,
            getPartnersForPath: getPartnersForPath,
            resolveNotesForPath: resolveNotesForPath,
            backupQuestionSet: backupQuestionSet,
            updateRequiredDownloadPrompt: updateRequiredDownloadPrompt,
            updateBlobSummmaryFileName: updateBlobSummmaryFileName
        };
    }

    workflowStateService.$inject = ['$rootScope', '$log', '$filter', '$timeout',
        'workflowDataService', 'notifyService', 'sessionDataService',
        'mailRequestDataService', 'workflowConfigurationDataService'];

    angular.module('ecap.workflow').factory('workflowStateService', workflowStateService);
})();
